import { useTopBarPortalContext } from './TopBarPortalProvider'
import { Box } from '@mui/material'

export default function TopBarPortal({ isPrimary = true }) {
  const { setPortalNode, setSecondPortalNode } = useTopBarPortalContext()
  return (
    <Box
      ref={isPrimary ? setPortalNode : setSecondPortalNode}
      data-portal-id={`top-bar-portal-${isPrimary ? 'primary' : 'secondary'}`}
      sx={{ position: 'relative' }}
    />
  )
}
